import { InviteDetails } from '../../../types';
import { verticalValidator } from '../../../services/verticalValidator';
import { i18n } from '../../../services/i18n';
import { preferredAppService } from '../../../services/preferred-app';

const getTitle = (inviteDetails: InviteDetails) => {
  const { inviteLevel, appType, placeName, itemName, vertical } = inviteDetails;
  const validVertical = verticalValidator.getValidVerticalForText(vertical);
  const appFullName = preferredAppService.getAppFullName(appType);
  if (inviteLevel === '1st') {
    switch (appType) {
      case 'WixOneApp':
      case 'WixFitnessApp':
        return i18n('lp.mobile.1st.title.default', { placeName, appFullName });
      case 'WixRestaurantsApp':
        return i18n('lp.mobile.1st.title.dine', { placeName, appFullName });
      case 'WixBrandedApp':
        return i18n('lp.mobile.1st.title.branded', { appName: placeName });
    }
  } else if (inviteLevel === '2nd') {
    return i18n(`lp.mobile.2nd.title.${validVertical}`, { itemName });
  }
};

const getSubtitle = (inviteDetails: InviteDetails) => {
  const { inviteLevel, appType, placeName, vertical, itemName } = inviteDetails;
  const validVertical = verticalValidator.getValidVerticalForText(vertical);
  const appFullName = preferredAppService.getAppFullName(appType);
  if (inviteLevel === '1st') {
    return i18n(`lp.mobile.1st.subtitle.${validVertical}`, { placeName });
  } else if (inviteLevel === '2nd') {
    switch (appType) {
      case 'WixOneApp':
      case 'WixFitnessApp':
        return i18n(`lp.mobile.2nd.subtitle.${validVertical}`, {
          appFullName,
          placeName,
          itemName,
        });
      case 'WixRestaurantsApp':
        return i18n(`lp.mobile.2nd.subtitle.dine.${validVertical}`, {
          appFullName,
          placeName,
          itemName,
        });
      case 'WixBrandedApp':
        return i18n(`lp.mobile.2nd.subtitle.branded.${validVertical}`, {
          appName: placeName,
          itemName,
        });
    }
  }
};

const getAppLogo = (appType: InviteDetails['appType']) => {
  const appName = preferredAppService.getAppName(appType);
  return require(`../assets/logo_${appName}.png`);
};

const getAppStoreLogo = () => {
  return require(`../assets/logo_apple.png`);
};

const getGooglePlayLogo = () => {
  return require(`../assets/logo_google_play.png`);
};

const getCoverImage = (inviteDetails: InviteDetails) => {
  return inviteDetails.coverImageUrl;
};

const getPlaceImage = (inviteDetails: InviteDetails) => {
  const { appType, placeImageUrl } = inviteDetails;
  const appName = preferredAppService.getAppName(appType);
  return (
    placeImageUrl ?? require(`../../assets/place_image_placeholder_${appName}.png`)
  );
};

const getItemImage = (inviteDetails: InviteDetails) => {
  const { vertical } = inviteDetails;
  const validVertical = verticalValidator.getValidVerticalForAssets(vertical);
  return (
    inviteDetails.itemImageUrl ??
    require(`../../assets/item_image_placeholder_${validVertical}.png`)
  );
};

const getDownloadCtaColor = (appType: InviteDetails['appType']) => {
  switch (appType) {
    case 'WixFitnessApp':
      return '#046A5B';
    case 'WixRestaurantsApp':
      return '#5B0FC6';
    default:
      return '#116DFF';
  }
};

export const inviteDetailsPresenter = {
  getTitle,
  getSubtitle,
  getGooglePlayLogo,
  getAppStoreLogo,
  getPlaceImage,
  getCoverImage,
  getAppLogo,
  getItemImage,
  getDownloadCtaColor,
};
